import Cookie from 'cookie';
import JSCookie from 'js-cookie';
import { createContext, useContext, useMemo, useState } from 'react';

export const parseCookies = (req) => Cookie.parse(req ? req.headers.cookie || '' : document.cookie);

export const CookieContext = createContext(null);

export class CookieController {
  private readonly cookie?: Record<string, any>;

  constructor(cookieString: string) {
    try {
      this.cookie = Cookie.parse(cookieString);
    } catch (_e) {
      this.cookie = {};
    }
  }

  public getAll() {
    if (typeof document !== 'undefined') {
      return JSCookie.get();
    }

    return this.cookie;
  }

  public set(name, value, options) {
    if (typeof document !== 'undefined') {
      return JSCookie.set(name, value, options);
    }
  }
}

const useCookie = () => {
  const cookieString = useContext(CookieContext);
  const controller = useMemo(() => new CookieController(cookieString), [cookieString]);
  const [cookies, setCookie] = useState(controller.getAll());

  const setCookieHandle = useMemo(
    () => (name, value, options) => {
      controller.set(name, value, options);
      setCookie(controller.getAll());
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cookies, controller],
  );

  return [cookies, setCookieHandle];
};

export default useCookie;
